import { FC } from 'react';
import Moment from 'react-moment';
import { useLastAvailableDate } from '../../../hooks/last-available-date/use-last-available-date.hook';
import { DEFAULT_DATE_FORMAT } from '../../../utils/formatting/date-formatter.helper';
import './last-run-model-component.scss';

interface LastRunModelComponentProps {
  reportId?: string;
  filterSelection: any;
  enabled?: boolean;
  reportName: string;
}

export const LastRunModelComponent: FC<LastRunModelComponentProps> = ({
  reportId,
  filterSelection,
  enabled,
  reportName,
}) => {
  const lastUpdated = useLastAvailableDate(filterSelection, reportId, enabled);
  return (
    <div className="last-run-model d-flex">
      <div className="d-lg-flex">
        <span className="last-run-title last-run-text">Data Source:</span>
        <span className="last-run-value last-run-text text-end">
          {reportName}
        </span>
      </div>
      <div className="d-lg-flex">
        <span className="last-run-title last-run-text">Last Updated:</span>
        <span className="last-run-value last-run-text text-end">
          <Moment date={lastUpdated} utc={true} format={DEFAULT_DATE_FORMAT} />
        </span>
      </div>
    </div>
  );
};
